import type { ElementType, ComponentPropsWithoutRef } from "react";

type DropdownProperties<T extends ElementType = "span"> = {
  as?: T;
  className?: string | undefined;
} & Omit<ComponentPropsWithoutRef<T>, "as" | "className">;

export const HeaderMenuItem = <T extends ElementType = "span">({
  children,
  as,
  className = "",
  ...properties
}: DropdownProperties<T>) => {
  const Component = as ?? "span";
  return (
    <Component
      className={`peer relative flex grow flex-col px-4 pb-4 pt-2 text-left text-l-body transition-colors focus-visible:outline focus-visible:outline-1 focus-visible:outline-offset-[3px] focus-visible:outline-white group-has-[*:focus-visible]/dropdown:bg-off-white group-has-[*:focus-visible]/dropdown:text-core-blue aria-expanded:bg-off-white aria-expanded:text-core-blue md:flex-row md:items-center md:justify-center md:gap-2 md:p-0 md:text-s-heading md:transition-none md:after:absolute md:after:bottom-0 md:after:h-1 md:after:w-0 md:after:bg-orange md:after:transition-all md:after:content-['_'] hover:md:after:w-full focus-visible:md:outline-none focus-visible:md:after:w-full md:group-focus-within/dropdown:after:w-full md:group-focus-within:after:w-full md:group-has-[*:focus-visible]/dropdown:bg-inherit md:group-has-[*:focus-visible]/dropdown:text-inherit  md:aria-expanded:bg-transparent md:aria-expanded:text-white aria-expanded:md:after:w-full ${className}`}
      {...properties}
    >
      {children}
    </Component>
  );
};
